import { render } from "./CancelPayment.vue?vue&type=template&id=694b3386"
import script from "./CancelPayment.vue?vue&type=script&lang=js"
export * from "./CancelPayment.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__